import { Controller } from '@hotwired/stimulus';

// スタイルガイドの目次 (#3227)。表示中のセクションに対応するリンクを
// ハイライトし、リンクのクリックでスムーススクロールする。
//
// rootMargin はハイライトの切り替わる位置を決めるため、値を変えない。
export default class extends Controller {
  static values = {
    sectionSelector: { type: String, default: 'section.sec' },
    rootMargin: { type: String, default: '-8% 0px -82% 0px' },
    offset: { type: Number, default: 10 },
  };

  connect() {
    this.links = [...this.element.querySelectorAll('a')];
    this.linkById = {};
    this.links.forEach((a) => {
      this.linkById[this.targetId(a)] = a;
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.links.forEach((l) => l.classList.remove('active'));
          const link = this.linkById[entry.target.id];
          if (link) link.classList.add('active');
        });
      },
      { rootMargin: this.rootMarginValue, threshold: 0 },
    );

    // 監視対象のセクションは目次の外にあるため document から引く。
    document.querySelectorAll(this.sectionSelectorValue).forEach((s) => this.observer.observe(s));
  }

  // ページを離れても監視が残らないようにする。
  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  scrollTo(event) {
    const link = event.currentTarget;
    const el = document.getElementById(this.targetId(link));
    if (!el) return;

    event.preventDefault();
    window.scrollTo({ top: el.offsetTop - this.offsetValue, behavior: 'smooth' });
  }

  targetId(link) {
    return (link.getAttribute('href') || '').slice(1);
  }
}
